// src/lib/i18n.js — Full translations for all 9 languages

export const TRANSLATIONS = {
  en: {
    // Navigation
    home: 'Home', shop: 'Shop', account: 'Account', admin: 'Admin',
    cart: 'Cart', search: 'Search products…', login: 'Login', signup: 'Sign Up',
    logout: 'Log Out', back: 'Back',
    // Age gate
    age_title: 'Age Verification Required',
    age_body: 'CosmiqHerbz sells botanical collector\'s items for adults only. You must be 18 or older to enter.',
    age_enter: 'I am 18+ — Enter',
    age_exit: 'Under 18 — Exit',
    age_note: 'All products are sold as collector\'s items only — not for consumption. By entering you confirm you are of legal age.',
    // Categories
    new_arrivals: 'New Arrivals', cbd_flower: 'CBD Flower', hemp_resin: 'Hemp Resin',
    vapes_carts: 'Vapes & Carts', bundles: 'Bundles',
    // Products
    add_to_cart: 'Add to Cart', added: 'Added', out_of_stock: 'Out of Stock',
    in_stock: 'In Stock', view_all: 'View all', featured: 'Featured',
    new_badge: 'New', bestseller: 'Bestseller', sale: 'Sale',
    // Cart
    your_cart: 'Your Collection', empty_cart: 'Your collection is empty',
    subtotal: 'Subtotal', shipping: 'Shipping', total: 'Total',
    free_shipping: 'Free shipping', checkout: 'Proceed to Checkout',
    free_shipping_msg: 'Free EU shipping on orders over €60',
    // Checkout — ALWAYS shows EUR
    checkout_title: 'Checkout',
    payment_notice: 'All payments are processed in EUR. The EUR amount shown is the exact amount you will be charged.',
    pay_now: 'Pay Now',
    order_summary: 'Order Summary',
    // Account
    my_account: 'My Account', my_orders: 'My Orders', wishlist: 'Wishlist',
    loyalty: 'Loyalty Points', settings: 'Settings', notifications: 'Notifications',
    language_currency: 'Language & Currency', privacy: 'Privacy & Legal',
    // Auth
    email: 'Email address', password: 'Password', confirm_password: 'Confirm password',
    full_name: 'Full name', sign_in: 'Sign In', create_account: 'Create Account',
    forgot_password: 'Forgot password?', or_continue: 'or continue with',
    google: 'Continue with Google', apple: 'Continue with Apple',
    already_account: 'Already have an account?', no_account: 'Don\'t have an account?',
    gdpr_consent: 'I agree to the Privacy Policy and Terms & Conditions. I confirm I am 18+ years old.',
    marketing_consent: 'I\'d like to receive news and exclusive offers by email (optional)',
    // Loyalty
    loyalty_title: 'Loyalty Programme', your_points: 'Your Points',
    stone_tier: '🪨 Stone', crystal_tier: '💎 Crystal', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'points to next tier', earn_info: 'Earn 1 point per €1 spent',
    // Legal
    collector_notice: 'Collector\'s Items Only: All products are sold exclusively for display and collection purposes. Not intended for consumption. All hemp products contain <0.2% THC per EU Regulation 2021/2115. 18+ only.',
    // Admin
    admin_panel: 'Admin Panel', dashboard: 'Dashboard', products: 'Products',
    prices_stock: 'Prices & Stock', blog: 'Blog Posts', newsletter: 'Newsletter',
    customers: 'Customers', analytics: 'Analytics', orders: 'Orders',
    add_product: 'Add Product', edit_product: 'Edit Product', save: 'Save',
    cancel: 'Cancel', delete: 'Delete', publish: 'Publish', draft: 'Draft',
    send_newsletter: 'Send Newsletter', revenue: 'Revenue', today: 'Today',
    // Messages
    success: 'Success', error: 'Error', loading: 'Loading…', confirm: 'Confirm',
  },
  de: {
    home: 'Startseite', shop: 'Shop', account: 'Konto', admin: 'Admin',
    cart: 'Warenkorb', search: 'Produkte suchen…', login: 'Anmelden', signup: 'Registrieren',
    logout: 'Abmelden', back: 'Zurück',
    age_title: 'Altersverifizierung erforderlich',
    age_body: 'CosmiqHerbz verkauft botanische Sammlerstücke nur an Erwachsene. Sie müssen 18 Jahre oder älter sein.',
    age_enter: 'Ich bin 18+ — Eintreten', age_exit: 'Unter 18 — Verlassen',
    age_note: 'Alle Produkte werden nur als Sammlerstücke verkauft — nicht zum Verzehr. Mit dem Eintreten bestätigen Sie, dass Sie volljährig sind.',
    new_arrivals: 'Neuheiten', cbd_flower: 'CBD Blüten', hemp_resin: 'Hanfharz',
    vapes_carts: 'Vapes & Carts', bundles: 'Pakete',
    add_to_cart: 'In den Warenkorb', added: 'Hinzugefügt', out_of_stock: 'Ausverkauft',
    in_stock: 'Auf Lager', view_all: 'Alle ansehen', featured: 'Empfohlen',
    new_badge: 'Neu', bestseller: 'Bestseller', sale: 'Angebot',
    your_cart: 'Deine Sammlung', empty_cart: 'Deine Sammlung ist leer',
    subtotal: 'Zwischensumme', shipping: 'Versand', total: 'Gesamt',
    free_shipping: 'Kostenloser Versand', checkout: 'Zur Kasse',
    free_shipping_msg: 'Kostenloser EU-Versand ab €60',
    checkout_title: 'Kasse',
    payment_notice: 'Alle Zahlungen werden in EUR verarbeitet. Der angezeigte EUR-Betrag ist der genaue Betrag, der berechnet wird.',
    pay_now: 'Jetzt bezahlen', order_summary: 'Bestellübersicht',
    my_account: 'Mein Konto', my_orders: 'Meine Bestellungen', wishlist: 'Wunschliste',
    loyalty: 'Treuepunkte', settings: 'Einstellungen', notifications: 'Benachrichtigungen',
    language_currency: 'Sprache & Währung', privacy: 'Datenschutz & Rechtliches',
    email: 'E-Mail-Adresse', password: 'Passwort', confirm_password: 'Passwort bestätigen',
    full_name: 'Vollständiger Name', sign_in: 'Anmelden', create_account: 'Konto erstellen',
    forgot_password: 'Passwort vergessen?', or_continue: 'oder weiter mit',
    google: 'Mit Google fortfahren', apple: 'Mit Apple fortfahren',
    already_account: 'Bereits ein Konto?', no_account: 'Noch kein Konto?',
    gdpr_consent: 'Ich stimme der Datenschutzrichtlinie und den AGB zu. Ich bestätige, dass ich 18+ Jahre alt bin.',
    marketing_consent: 'Ich möchte Neuigkeiten und Angebote per E-Mail erhalten (optional)',
    loyalty_title: 'Treueprogramm', your_points: 'Ihre Punkte',
    stone_tier: '🪨 Stein', crystal_tier: '💎 Kristall', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'Punkte bis zur nächsten Stufe', earn_info: '1 Punkt pro ausgegebenem €1',
    collector_notice: 'Nur Sammlerstücke: Alle Produkte werden ausschließlich für Sammlerzwecke verkauft. Nicht zum Verzehr bestimmt. 18+ nur.',
    admin_panel: 'Adminbereich', dashboard: 'Dashboard', products: 'Produkte',
    prices_stock: 'Preise & Lager', blog: 'Blogbeiträge', newsletter: 'Newsletter',
    customers: 'Kunden', analytics: 'Analytik', orders: 'Bestellungen',
    add_product: 'Produkt hinzufügen', edit_product: 'Produkt bearbeiten', save: 'Speichern',
    cancel: 'Abbrechen', delete: 'Löschen', publish: 'Veröffentlichen', draft: 'Entwurf',
    send_newsletter: 'Newsletter senden', revenue: 'Umsatz', today: 'Heute',
    success: 'Erfolg', error: 'Fehler', loading: 'Laden…', confirm: 'Bestätigen',
  },
  sk: {
    home: 'Domov', shop: 'Obchod', account: 'Účet', admin: 'Admin',
    cart: 'Košík', search: 'Hľadať produkty…', login: 'Prihlásiť', signup: 'Registrovať',
    logout: 'Odhlásiť', back: 'Späť',
    age_title: 'Vyžaduje sa overenie veku',
    age_body: 'CosmiqHerbz predáva botanické zberateľské predmety iba pre dospelých. Musíte mať 18 rokov alebo viac.',
    age_enter: 'Mám 18+ — Vstúpiť', age_exit: 'Menej ako 18 — Odísť',
    age_note: 'Všetky produkty sa predávajú iba ako zberateľské predmety — nie na konzumáciu.',
    new_arrivals: 'Novinky', cbd_flower: 'CBD Kvet', hemp_resin: 'Konopná Živica',
    vapes_carts: 'Vapes a Cartridge', bundles: 'Balíčky',
    add_to_cart: 'Pridať do košíka', added: 'Pridané', out_of_stock: 'Vypredané',
    in_stock: 'Na sklade', view_all: 'Zobraziť všetko', featured: 'Odporúčané',
    new_badge: 'Nové', bestseller: 'Bestseller', sale: 'Zľava',
    your_cart: 'Vaša zbierka', empty_cart: 'Vaša zbierka je prázdna',
    subtotal: 'Medzisúčet', shipping: 'Doprava', total: 'Spolu',
    free_shipping: 'Doprava zadarmo', checkout: 'Pokračovať k platbe',
    free_shipping_msg: 'Doprava zadarmo v EÚ pri objednávke nad €60',
    checkout_title: 'Pokladňa',
    payment_notice: 'Všetky platby sú spracované v EUR. Zobrazená suma EUR je presná suma, ktorá vám bude účtovaná.',
    pay_now: 'Zaplatiť', order_summary: 'Prehľad objednávky',
    my_account: 'Môj účet', my_orders: 'Moje objednávky', wishlist: 'Zoznam želaní',
    loyalty: 'Vernostné body', settings: 'Nastavenia', notifications: 'Upozornenia',
    language_currency: 'Jazyk a mena', privacy: 'Ochrana súkromia a právne informácie',
    email: 'E-mailová adresa', password: 'Heslo', confirm_password: 'Potvrdiť heslo',
    full_name: 'Celé meno', sign_in: 'Prihlásiť sa', create_account: 'Vytvoriť účet',
    forgot_password: 'Zabudli ste heslo?', or_continue: 'alebo pokračujte s',
    google: 'Pokračovať cez Google', apple: 'Pokračovať cez Apple',
    already_account: 'Už máte účet?', no_account: 'Nemáte účet?',
    gdpr_consent: 'Súhlasím so zásadami ochrany osobných údajov a obchodnými podmienkami. Potvrdzujem, že mám 18+ rokov.',
    marketing_consent: 'Chcem dostávať novinky a ponuky e-mailom (voliteľné)',
    loyalty_title: 'Vernostný program', your_points: 'Vaše body',
    stone_tier: '🪨 Kameň', crystal_tier: '💎 Krištáľ', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'bodov do ďalšej úrovne', earn_info: '1 bod za každé vynaložené €1',
    collector_notice: 'Iba zberateľské predmety: Všetky produkty sa predávajú výhradne na zberateľské účely. Nie na konzumáciu. 18+ len.',
    admin_panel: 'Admin panel', dashboard: 'Prehľad', products: 'Produkty',
    prices_stock: 'Ceny a sklad', blog: 'Blogové príspevky', newsletter: 'Newsletter',
    customers: 'Zákazníci', analytics: 'Analytika', orders: 'Objednávky',
    add_product: 'Pridať produkt', edit_product: 'Upraviť produkt', save: 'Uložiť',
    cancel: 'Zrušiť', delete: 'Vymazať', publish: 'Publikovať', draft: 'Návrh',
    send_newsletter: 'Odoslať newsletter', revenue: 'Príjmy', today: 'Dnes',
    success: 'Úspech', error: 'Chyba', loading: 'Načítavam…', confirm: 'Potvrdiť',
  },
  hu: {
    home: 'Főoldal', shop: 'Bolt', account: 'Fiókom', admin: 'Admin',
    cart: 'Kosár', search: 'Termékek keresése…', login: 'Bejelentkezés', signup: 'Regisztráció',
    logout: 'Kijelentkezés', back: 'Vissza',
    age_title: 'Korhatár-ellenőrzés szükséges',
    age_body: 'A CosmiqHerbz botanikai gyűjtőtárgyakat csak felnőtteknek értékesít. Legalább 18 évesnek kell lennie.',
    age_enter: '18+ vagyok — Belépés', age_exit: '18 alatt — Kilépés',
    age_note: 'Minden terméket kizárólag gyűjtői célokra értékesítünk — nem fogyasztásra.',
    new_arrivals: 'Újdonságok', cbd_flower: 'CBD Virág', hemp_resin: 'Kender Gyanta',
    vapes_carts: 'Vape-ek és Patronok', bundles: 'Csomagok',
    add_to_cart: 'Kosárba', added: 'Hozzáadva', out_of_stock: 'Elfogyott',
    in_stock: 'Készleten', view_all: 'Összes megtekintése', featured: 'Kiemelt',
    new_badge: 'Új', bestseller: 'Bestseller', sale: 'Akció',
    your_cart: 'Az Ön gyűjteménye', empty_cart: 'A gyűjtemény üres',
    subtotal: 'Részösszeg', shipping: 'Szállítás', total: 'Összesen',
    free_shipping: 'Ingyenes szállítás', checkout: 'Pénztárhoz',
    free_shipping_msg: 'Ingyenes EU szállítás €60 feletti rendelésnél',
    checkout_title: 'Pénztár',
    payment_notice: 'Minden fizetés EUR-ban történik. A megjelenített EUR összeg a pontos összeg, amelyet felszámítunk.',
    pay_now: 'Fizetés', order_summary: 'Rendelés összegzése',
    my_account: 'Fiókom', my_orders: 'Rendeléseim', wishlist: 'Kívánságlista',
    loyalty: 'Hűségpontok', settings: 'Beállítások', notifications: 'Értesítések',
    language_currency: 'Nyelv és pénznem', privacy: 'Adatvédelem és jogi információk',
    email: 'E-mail cím', password: 'Jelszó', confirm_password: 'Jelszó megerősítése',
    full_name: 'Teljes név', sign_in: 'Bejelentkezés', create_account: 'Fiók létrehozása',
    forgot_password: 'Elfelejtette jelszavát?', or_continue: 'vagy folytatás',
    google: 'Folytatás Google-lal', apple: 'Folytatás Apple-lel',
    already_account: 'Már van fiókja?', no_account: 'Nincs fiókja?',
    gdpr_consent: 'Elfogadom az Adatvédelmi irányelveket és az ÁSZF-et. Megerősítem, hogy 18 éves vagy idősebb vagyok.',
    marketing_consent: 'Szeretnék hírleveleket és ajánlatokat kapni e-mailben (opcionális)',
    loyalty_title: 'Hűségprogram', your_points: 'Az Ön pontjai',
    stone_tier: '🪨 Kő', crystal_tier: '💎 Kristály', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'pont a következő szintig', earn_info: '1 pont minden elköltött €1 után',
    collector_notice: 'Csak gyűjtői tárgyak: Minden termék kizárólag gyűjtési célokra értékesített. Nem fogyasztásra szánt. Csak 18+.',
    admin_panel: 'Admin panel', dashboard: 'Irányítópult', products: 'Termékek',
    prices_stock: 'Árak és készlet', blog: 'Blog bejegyzések', newsletter: 'Hírlevél',
    customers: 'Ügyfelek', analytics: 'Elemzések', orders: 'Rendelések',
    add_product: 'Termék hozzáadása', edit_product: 'Termék szerkesztése', save: 'Mentés',
    cancel: 'Mégse', delete: 'Törlés', publish: 'Közzététel', draft: 'Piszkozat',
    send_newsletter: 'Hírlevél küldése', revenue: 'Bevétel', today: 'Ma',
    success: 'Siker', error: 'Hiba', loading: 'Betöltés…', confirm: 'Megerősítés',
  },
  ro: {
    home: 'Acasă', shop: 'Magazin', account: 'Contul meu', admin: 'Admin',
    cart: 'Coș', search: 'Caută produse…', login: 'Autentificare', signup: 'Înregistrare',
    logout: 'Deconectare', back: 'Înapoi',
    age_title: 'Verificare vârstă necesară',
    age_body: 'CosmiqHerbz vinde articole botanice de colecție doar adulților. Trebuie să aveți 18 ani sau mai mult.',
    age_enter: 'Am 18+ — Intră', age_exit: 'Sub 18 — Ieși',
    age_note: 'Toate produsele sunt vândute exclusiv ca articole de colecție — nu pentru consum.',
    new_arrivals: 'Noutăți', cbd_flower: 'Floare CBD', hemp_resin: 'Rășină Cânepă',
    vapes_carts: 'Vape-uri și Cartușe', bundles: 'Pachete',
    add_to_cart: 'Adaugă în coș', added: 'Adăugat', out_of_stock: 'Stoc epuizat',
    in_stock: 'În stoc', view_all: 'Vezi toate', featured: 'Recomandate',
    new_badge: 'Nou', bestseller: 'Bestseller', sale: 'Reducere',
    your_cart: 'Colecția dvs.', empty_cart: 'Colecția este goală',
    subtotal: 'Subtotal', shipping: 'Livrare', total: 'Total',
    free_shipping: 'Livrare gratuită', checkout: 'Spre casă',
    free_shipping_msg: 'Livrare UE gratuită la comenzi peste €60',
    checkout_title: 'Casă',
    payment_notice: 'Toate plățile sunt procesate în EUR. Suma EUR afișată este suma exactă care vă va fi taxată.',
    pay_now: 'Plătește acum', order_summary: 'Rezumat comandă',
    my_account: 'Contul meu', my_orders: 'Comenzile mele', wishlist: 'Lista de dorințe',
    loyalty: 'Puncte de fidelitate', settings: 'Setări', notifications: 'Notificări',
    language_currency: 'Limbă și monedă', privacy: 'Confidențialitate și legal',
    email: 'Adresă de email', password: 'Parolă', confirm_password: 'Confirmă parola',
    full_name: 'Nume complet', sign_in: 'Autentificare', create_account: 'Creează cont',
    forgot_password: 'Ai uitat parola?', or_continue: 'sau continuă cu',
    google: 'Continuă cu Google', apple: 'Continuă cu Apple',
    already_account: 'Ai deja cont?', no_account: 'Nu ai cont?',
    gdpr_consent: 'Sunt de acord cu Politica de confidențialitate și Termenii și condițiile. Confirm că am 18+ ani.',
    marketing_consent: 'Doresc să primesc știri și oferte prin email (opțional)',
    loyalty_title: 'Program de fidelitate', your_points: 'Punctele dvs.',
    stone_tier: '🪨 Piatră', crystal_tier: '💎 Cristal', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'puncte până la nivelul următor', earn_info: '1 punct pentru fiecare €1 cheltuit',
    collector_notice: 'Doar articole de colecție: Toate produsele sunt vândute exclusiv în scopuri de colecție. Nu sunt destinate consumului. Doar 18+.',
    admin_panel: 'Panou admin', dashboard: 'Tablou de bord', products: 'Produse',
    prices_stock: 'Prețuri și stoc', blog: 'Articole blog', newsletter: 'Newsletter',
    customers: 'Clienți', analytics: 'Analize', orders: 'Comenzi',
    add_product: 'Adaugă produs', edit_product: 'Editează produs', save: 'Salvează',
    cancel: 'Anulează', delete: 'Șterge', publish: 'Publică', draft: 'Ciornă',
    send_newsletter: 'Trimite newsletter', revenue: 'Venituri', today: 'Azi',
    success: 'Succes', error: 'Eroare', loading: 'Se încarcă…', confirm: 'Confirmă',
  },
  pl: {
    home: 'Strona główna', shop: 'Sklep', account: 'Moje konto', admin: 'Admin',
    cart: 'Koszyk', search: 'Szukaj produktów…', login: 'Zaloguj', signup: 'Zarejestruj',
    logout: 'Wyloguj', back: 'Wstecz',
    age_title: 'Wymagana weryfikacja wieku',
    age_body: 'CosmiqHerbz sprzedaje botaniczne przedmioty kolekcjonerskie wyłącznie dorosłym. Musisz mieć 18 lat lub więcej.',
    age_enter: 'Mam 18+ — Wejdź', age_exit: 'Poniżej 18 — Wyjdź',
    age_note: 'Wszystkie produkty sprzedawane są wyłącznie jako przedmioty kolekcjonerskie — nie do spożycia.',
    new_arrivals: 'Nowości', cbd_flower: 'Kwiat CBD', hemp_resin: 'Żywica Konopna',
    vapes_carts: 'Vape i Kartridże', bundles: 'Zestawy',
    add_to_cart: 'Dodaj do koszyka', added: 'Dodano', out_of_stock: 'Brak w magazynie',
    in_stock: 'W magazynie', view_all: 'Zobacz wszystko', featured: 'Polecane',
    new_badge: 'Nowe', bestseller: 'Bestseller', sale: 'Wyprzedaż',
    your_cart: 'Twoja kolekcja', empty_cart: 'Twoja kolekcja jest pusta',
    subtotal: 'Suma częściowa', shipping: 'Wysyłka', total: 'Łącznie',
    free_shipping: 'Darmowa wysyłka', checkout: 'Do kasy',
    free_shipping_msg: 'Darmowa wysyłka UE przy zamówieniu powyżej €60',
    checkout_title: 'Kasa',
    payment_notice: 'Wszystkie płatności są przetwarzane w EUR. Wyświetlona kwota EUR jest dokładną kwotą, która zostanie pobrana.',
    pay_now: 'Zapłać teraz', order_summary: 'Podsumowanie zamówienia',
    my_account: 'Moje konto', my_orders: 'Moje zamówienia', wishlist: 'Lista życzeń',
    loyalty: 'Punkty lojalnościowe', settings: 'Ustawienia', notifications: 'Powiadomienia',
    language_currency: 'Język i waluta', privacy: 'Prywatność i prawo',
    email: 'Adres e-mail', password: 'Hasło', confirm_password: 'Potwierdź hasło',
    full_name: 'Imię i nazwisko', sign_in: 'Zaloguj się', create_account: 'Utwórz konto',
    forgot_password: 'Zapomniałeś hasła?', or_continue: 'lub kontynuuj z',
    google: 'Kontynuuj z Google', apple: 'Kontynuuj z Apple',
    already_account: 'Masz już konto?', no_account: 'Nie masz konta?',
    gdpr_consent: 'Zgadzam się z Polityką prywatności i Regulaminem. Potwierdzam, że mam 18+ lat.',
    marketing_consent: 'Chcę otrzymywać informacje i oferty e-mailem (opcjonalnie)',
    loyalty_title: 'Program lojalnościowy', your_points: 'Twoje punkty',
    stone_tier: '🪨 Kamień', crystal_tier: '💎 Kryształ', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'punktów do następnego poziomu', earn_info: '1 punkt za każde wydane €1',
    collector_notice: 'Tylko przedmioty kolekcjonerskie: Wszystkie produkty sprzedawane są wyłącznie w celach kolekcjonerskich. Nie do spożycia. Tylko 18+.',
    admin_panel: 'Panel admina', dashboard: 'Pulpit', products: 'Produkty',
    prices_stock: 'Ceny i zapasy', blog: 'Wpisy na blogu', newsletter: 'Newsletter',
    customers: 'Klienci', analytics: 'Analityka', orders: 'Zamówienia',
    add_product: 'Dodaj produkt', edit_product: 'Edytuj produkt', save: 'Zapisz',
    cancel: 'Anuluj', delete: 'Usuń', publish: 'Opublikuj', draft: 'Szkic',
    send_newsletter: 'Wyślij newsletter', revenue: 'Przychody', today: 'Dziś',
    success: 'Sukces', error: 'Błąd', loading: 'Ładowanie…', confirm: 'Potwierdź',
  },
  hr: {
    home: 'Početna', shop: 'Trgovina', account: 'Moj račun', admin: 'Admin',
    cart: 'Košarica', search: 'Pretraži proizvode…', login: 'Prijava', signup: 'Registracija',
    logout: 'Odjava', back: 'Nazad',
    age_title: 'Potrebna provjera dobi',
    age_body: 'CosmiqHerbz prodaje botaničke kolekcionarske predmete samo odraslima. Morate imati 18 ili više godina.',
    age_enter: 'Imam 18+ — Ulaz', age_exit: 'Ispod 18 — Izlaz',
    age_note: 'Svi proizvodi se prodaju isključivo kao kolekcionarski predmeti — nisu namijenjeni konzumaciji.',
    new_arrivals: 'Novosti', cbd_flower: 'CBD Cvijet', hemp_resin: 'Konopljina Smola',
    vapes_carts: 'Vape-ovi i Uložaci', bundles: 'Paketi',
    add_to_cart: 'Dodaj u košaricu', added: 'Dodano', out_of_stock: 'Nema na zalihi',
    in_stock: 'Na zalihi', view_all: 'Pogledaj sve', featured: 'Istaknuto',
    new_badge: 'Novo', bestseller: 'Bestseler', sale: 'Akcija',
    your_cart: 'Vaša kolekcija', empty_cart: 'Vaša kolekcija je prazna',
    subtotal: 'Međuzbroj', shipping: 'Dostava', total: 'Ukupno',
    free_shipping: 'Besplatna dostava', checkout: 'Na blagajnu',
    free_shipping_msg: 'Besplatna EU dostava za narudžbe iznad €60',
    checkout_title: 'Blagajna',
    payment_notice: 'Sve uplate se obrađuju u EUR-u. Prikazani EUR iznos je točan iznos koji će biti naplaćen.',
    pay_now: 'Plati sada', order_summary: 'Sažetak narudžbe',
    my_account: 'Moj račun', my_orders: 'Moje narudžbe', wishlist: 'Lista želja',
    loyalty: 'Bodovi vjernosti', settings: 'Postavke', notifications: 'Obavijesti',
    language_currency: 'Jezik i valuta', privacy: 'Privatnost i pravne informacije',
    email: 'Email adresa', password: 'Lozinka', confirm_password: 'Potvrdi lozinku',
    full_name: 'Puno ime', sign_in: 'Prijavi se', create_account: 'Stvori račun',
    forgot_password: 'Zaboravili ste lozinku?', or_continue: 'ili nastavite s',
    google: 'Nastavi s Google', apple: 'Nastavi s Apple',
    already_account: 'Već imate račun?', no_account: 'Nemate račun?',
    gdpr_consent: 'Slažem se s Politikom privatnosti i Uvjetima korištenja. Potvrđujem da imam 18+ godina.',
    marketing_consent: 'Želim primati vijesti i ponude e-mailom (opcionalno)',
    loyalty_title: 'Program vjernosti', your_points: 'Vaši bodovi',
    stone_tier: '🪨 Kamen', crystal_tier: '💎 Kristal', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'bodova do sljedeće razine', earn_info: '1 bod za svaki potrošeni €1',
    collector_notice: 'Samo kolekcionarski predmeti: Svi proizvodi prodaju se isključivo u svrhu kolekcioniranja. Nisu namijenjeni konzumaciji. Samo 18+.',
    admin_panel: 'Admin panel', dashboard: 'Nadzorna ploča', products: 'Proizvodi',
    prices_stock: 'Cijene i zalihe', blog: 'Blog objave', newsletter: 'Newsletter',
    customers: 'Kupci', analytics: 'Analitika', orders: 'Narudžbe',
    add_product: 'Dodaj proizvod', edit_product: 'Uredi proizvod', save: 'Spremi',
    cancel: 'Odustani', delete: 'Obriši', publish: 'Objavi', draft: 'Skica',
    send_newsletter: 'Pošalji newsletter', revenue: 'Prihod', today: 'Danas',
    success: 'Uspjeh', error: 'Greška', loading: 'Učitavanje…', confirm: 'Potvrdi',
  },
  nl: {
    home: 'Home', shop: 'Winkel', account: 'Mijn account', admin: 'Admin',
    cart: 'Winkelwagen', search: 'Producten zoeken…', login: 'Inloggen', signup: 'Registreren',
    logout: 'Uitloggen', back: 'Terug',
    age_title: 'Leeftijdsverificatie vereist',
    age_body: 'CosmiqHerbz verkoopt botanische verzamelobjecten alleen aan volwassenen. U moet 18 jaar of ouder zijn.',
    age_enter: 'Ik ben 18+ — Ga naar binnen', age_exit: 'Onder 18 — Vertrek',
    age_note: 'Alle producten worden uitsluitend verkocht als verzamelobjecten — niet voor consumptie.',
    new_arrivals: 'Nieuw', cbd_flower: 'CBD Bloem', hemp_resin: 'Hennepresine',
    vapes_carts: 'Vapes & Cartridges', bundles: 'Bundels',
    add_to_cart: 'Toevoegen aan winkelwagen', added: 'Toegevoegd', out_of_stock: 'Uitverkocht',
    in_stock: 'Op voorraad', view_all: 'Alles bekijken', featured: 'Uitgelicht',
    new_badge: 'Nieuw', bestseller: 'Bestseller', sale: 'Aanbieding',
    your_cart: 'Uw collectie', empty_cart: 'Uw collectie is leeg',
    subtotal: 'Subtotaal', shipping: 'Verzending', total: 'Totaal',
    free_shipping: 'Gratis verzending', checkout: 'Naar kassa',
    free_shipping_msg: 'Gratis EU-verzending bij bestellingen boven €60',
    checkout_title: 'Kassa',
    payment_notice: 'Alle betalingen worden verwerkt in EUR. Het weergegeven EUR-bedrag is het exacte bedrag dat in rekening wordt gebracht.',
    pay_now: 'Nu betalen', order_summary: 'Besteloverzicht',
    my_account: 'Mijn account', my_orders: 'Mijn bestellingen', wishlist: 'Verlanglijst',
    loyalty: 'Loyaliteitspunten', settings: 'Instellingen', notifications: 'Meldingen',
    language_currency: 'Taal en valuta', privacy: 'Privacy en juridisch',
    email: 'E-mailadres', password: 'Wachtwoord', confirm_password: 'Wachtwoord bevestigen',
    full_name: 'Volledige naam', sign_in: 'Inloggen', create_account: 'Account aanmaken',
    forgot_password: 'Wachtwoord vergeten?', or_continue: 'of ga verder met',
    google: 'Doorgaan met Google', apple: 'Doorgaan met Apple',
    already_account: 'Al een account?', no_account: 'Nog geen account?',
    gdpr_consent: 'Ik ga akkoord met het Privacybeleid en de Algemene voorwaarden. Ik bevestig dat ik 18+ jaar oud ben.',
    marketing_consent: 'Ik wil nieuws en aanbiedingen ontvangen via e-mail (optioneel)',
    loyalty_title: 'Loyaliteitsprogramma', your_points: 'Uw punten',
    stone_tier: '🪨 Steen', crystal_tier: '💎 Kristal', elite_tier: '🌌 Cosmiq Elite',
    pts_to_next: 'punten tot volgend niveau', earn_info: '1 punt per bestede €1',
    collector_notice: 'Alleen verzamelobjecten: Alle producten worden uitsluitend verkocht voor verzameldoeleinden. Niet voor consumptie. Alleen 18+.',
    admin_panel: 'Beheerpaneel', dashboard: 'Dashboard', products: 'Producten',
    prices_stock: 'Prijzen en voorraad', blog: 'Blogberichten', newsletter: 'Nieuwsbrief',
    customers: 'Klanten', analytics: 'Analyse', orders: 'Bestellingen',
    add_product: 'Product toevoegen', edit_product: 'Product bewerken', save: 'Opslaan',
    cancel: 'Annuleren', delete: 'Verwijderen', publish: 'Publiceren', draft: 'Concept',
    send_newsletter: 'Nieuwsbrief verzenden', revenue: 'Omzet', today: 'Vandaag',
    success: 'Succes', error: 'Fout', loading: 'Laden…', confirm: 'Bevestigen',
  },
};

export function t(key, lang = 'en') {
  return TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;
}
